import Vue from 'vue'
import AxiosRestService from '@gms/network/src/axiosRestService'

const initialState = () => ({
  myReservations: [],
  singleReservation: {},
  isLoading: false,
  hasValidToken: false,
  hasError: false,
})

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: initialState(),
  // -----------------------------------------------------------------
  getters: {
    myReservations: (state) => state.myReservations,
    reservationsCount: (state, getters) => getters.myReservations.length,
    singleReservation: (state) => state.singleReservation,
    isLoading: (state) => state.isLoading,
    hasValidToken: (state) => state.hasValidToken,
    hasError: (state) => state.hasError,
    allReservations: (state) => [
      ...state.myReservations,
      ...state.singleReservation,
    ],
    getReservationByToken(state) {
      return (reservationToken) => {
        const findToken = (reservation) => reservation.token === reservationToken
        return state.allReservations.find(findToken)
      }
    },
  },
  // -----------------------------------------------------------------
  mutations: {
    setMyReservations: (state, myReservations) => Vue.set(state, 'myReservations', myReservations),
    setSingleReservation: (state, singleReservation) => Vue.set(state, 'singleReservation', singleReservation),
    setIsLoading: (state, isLoading) => Vue.set(state, 'isLoading', isLoading),
    setHasValidToken: (state, hasValidToken) => Vue.set(state, 'hasValidToken', hasValidToken),
    setHasError: (state, hasError) => Vue.set(state, 'hasError', hasError),
    reset(state) {
      const newState = initialState()
      Object.keys(newState).forEach((key) => {
        state[key] = newState[key]
      })
    },
  },
  // -----------------------------------------------------------------
  actions: {
    fetchReservations: (context) => {
      context.commit('setIsLoading', true);
      AxiosRestService
        .get('/reservations/personal_index')
        .then((response) => {
          context.commit('setMyReservations', response.data)
          return Promise.resolve(context.state.myReservations)
        })
        .finally(() => {
          context.commit('setIsLoading', false);
        });
    },
    fetchAllowedSingleReservation: (context, token) => {
      context.commit('setIsLoading', true)
      return AxiosRestService
        .get(`/reservations/remote/${token}`)
        .then((response) => {
          context.commit('setSingleReservation', response.data)
          context.commit('setHasValidToken', true)
          context.commit('setHasError', false)
        })
        .catch((error) => {
          context.commit('setHasError', true)
          context.commit('setHasValidToken', false)
          context.commit('setSingleReservation', null)
          if (error.response.status) {
            context.commit('setHasValidToken', false)
          }
        })
        .finally(() => {
          context.commit('setIsLoading', false)
        })
    },
  },
}
